// ----------------------------------------------------------------------------
// Snippet: Cart Confirmation
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/modal/modal';

// Styles
import './_cart-confirmation.scss';

// Selectors
const HEADER_SELECTOR = '#shopify-section-header';
const CART_CONFIRMATION_MODAL_CONTENT_SELECTOR = '.modal--cart-confirmation .modal__content';

// Function to set the cart confirmation position based on screen width
function setCartConfirmationPosition() {
    const headerSection = document.querySelector(HEADER_SELECTOR);
    const cartConfirmationContent = document.querySelector(CART_CONFIRMATION_MODAL_CONTENT_SELECTOR);

    if (cartConfirmationContent !== null) {
        const topPosition = window.matchMedia('(min-width: 1024px)').matches ? `${headerSection.offsetHeight}px` : 'auto';
        cartConfirmationContent.style.top = topPosition;
    }
}

// Event listener for DOM content loaded
document.addEventListener('DOMContentLoaded', setCartConfirmationPosition);

// Event listener for window resize
window.addEventListener('resize', setCartConfirmationPosition);

// Event listener for scroll
window.addEventListener('scroll', setCartConfirmationPosition);
